function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function stringAvatar(name) {
  if (name === undefined || name === "") return "";
  return {
    sx: {
      bgcolor: stringToColor(name),
      width: 32,
      height: 32,
    },
    children: `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`,
  };
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function getAgeFromDOB(dob) {
  if (!dob) return 0;

  const today = new Date();
  let birthDate;

  // Handle YYYY-MM-DD format
  if (typeof dob === 'string' && dob.includes('-')) {
    const [year, month, day] = dob.split('-').map(num => parseInt(num, 10));
    birthDate = new Date(year, month - 1, day);
  } else {
    // Fallback for other formats
    birthDate = new Date(dob);
  }

  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

const StringUtils = {
  stringAvatar,
  capitalizeFirstLetter,
  getAgeFromDOB,
};

export default StringUtils;
